<template>
  <InspectionStep
    :phase="phase"
    :booking-id="bookingId"
    :allocation-id="allocationId"
    :navigate-next="handleNext"
  />
</template>

<script setup lang="ts">
import { useRoute, useRouter } from 'vue-router';
import { InspectionPhase } from '@carvia/ros-client-types';
import InspectionStep from '../inspection/InspectionStep.vue';

/**
 * Vehicle photos in a car swap: a return inspection of the car handed back before its status, and
 * a handover inspection of the new car before the swap protocol is signed.
 */
const props = defineProps<{
  phase: InspectionPhase;
}>();

const route = useRoute();
const router = useRouter();
const bookingId = route.params.bookingId as string;
const isReturn = props.phase === InspectionPhase.RETURN;
const allocationId = (isReturn ? route.query.swapFromId : route.query.swapToId) as string;

const handleNext = () =>
  router.push({
    name: isReturn ? 'swapReturnStatus' : 'swapProtocol',
    params: { bookingId },
    query: route.query,
  });
</script>
